import { render, staticRenderFns } from "./ConsultarEmenda.vue?vue&type=template&id=1d01249d&scoped=true"
import script from "./ConsultarEmenda.vue?vue&type=script&lang=ts"
export * from "./ConsultarEmenda.vue?vue&type=script&lang=ts"
import style0 from "./ConsultarEmenda.vue?vue&type=style&index=0&id=1d01249d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d01249d",
  null
  
)

export default component.exports